<!-- <div class="container-fluid">


  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-tag mr-2"></i> Tags
  </h1>

  <p class="lead mb-4">
    Manage and organize tags used across the platform. Here you can add new tags, view existing tags, and see their details such as the slug, publication status, and the number of items associated with each tag.
  </p>

  <div class="card mb-4">
    <div class="card-body">

      <button
        href="#addTagModal"
        role="button"
        data-toggle="modal"
        class="btn btn-success btn-icon-split"
      >
        <span class="icon text-white-50">
          <i class="fas fa-plus"></i>
        </span>
        <span class="text">Add Tag</span>
      </button>
      <div class="table-responsive">
        <table class="table table-bordered" id="dataTabled" width="100%" cellspacing="0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Slug</th>
              <th>Published</th>
              <th>Item(s)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tag Name 1</td>
              <td>tag-name-1</td>
              <td>Yes</td>
              <td>5</td>
            </tr>
            <tr>
              <td>Tag Name 2</td>
              <td>tag-name-2</td>
              <td>No</td>
              <td>3</td>
            </tr>
            <tr>
              <td>Tag Name 3</td>
              <td>tag-name-3</td>
              <td>Yes</td>
              <td>10</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="addTagModal" tabindex="-1" role="dialog" aria-labelledby="addTagModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addTagModalLabel"><i class="fas fa-plus-circle mr-2"></i>Add New Tag</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form id="addTagForm">
          <div class="form-group">
            <label for="tagName">Name</label>
            <input type="text" class="form-control" id="tagName" placeholder="Enter tag name" required>
          </div>
          <div class="form-group">
            <label for="tagSlug">Slug</label>
            <input type="text" class="form-control" id="tagSlug" placeholder="Enter tag slug" required>
          </div>
          <div class="form-group">
            <label for="tagPublished">Published</label>
            <select class="form-control" id="tagPublished" required>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          <button type="submit" class="btn btn-primary">Save Tag</button>
        </form>
      </div>
    </div>
  </div>
</div>
 -->
 <div #rendererContainer></div>